import React from 'react';
import styled from 'styled-components/macro';
import { headerHeight } from 'utils/styleConstants';

const ModuleNotFound = styled.div`
  height: calc(100vh - ${headerHeight}px);
  justify-content: center;
  display: flex;
  align-items: center;
`;

export default () => (
  <ModuleNotFound>
    <h2>Module not found</h2>
  </ModuleNotFound>
);
